import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-bottom: ", ";\n\tpadding-top: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-bottom: ", ";\n\tpadding-top: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tline-height: ", ";\n\tmargin: 0;\n\tmax-width: 100%;\n\tpadding-bottom: ", ";\n\tpadding-top: ", ";\n\n\t&:active {\n\t\tuser-select: none;\n\t}\n\n\t", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t> * {\n\t\tposition: relative;\n\t\ttop: 0.5px;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, getHighDpi, ui } from '@wp-g2/styles';
var lineHeight = "calc(" + ui.get('fontSize') + " * 1.2)";

function getPadding(size) {
  return "calc((" + ui.get(size) + " - " + lineHeight + ") / 2)";
}

var highDpiAdjust = getHighDpi(css(_templateObject()));
export var ControlLabel = css(_templateObject2(), lineHeight, getPadding('controlHeight'), getPadding('controlHeight'), highDpiAdjust);
export var large = css(_templateObject3(), getPadding('controlHeightLarge'), getPadding('controlHeightLarge'));
export var small = css(_templateObject4(), getPadding('controlHeightSmall'), getPadding('controlHeightSmall'));
export var inline = css(_templateObject5());
export var block = css(_templateObject6());